import React from 'react';
import { Box } from '@mui/material';

const CalendarBox = ({ isCancelled, noReceiver, statusColor, claimColor, ...rest }) => {
  const classes = () => {
    if (isCancelled && !noReceiver) {
      return 'rescue-cancelled';
    }

    if (noReceiver && !isCancelled) {
      return 'rescue-no_receiver';
    }

    if (noReceiver && isCancelled) {
      return 'rescue-cancelled-no_receiver';
    }

    return '';
  };

  return (
    <Box
      {...rest}
      className={classes()}
      sx={{
        width: '100%',
        paddingTop: '100%',
        aspectRatio: 1,
        backgroundImage: `linear-gradient(to bottom left, ${statusColor.color} 50%, ${claimColor.color} 50%)`,
        border: '1px solid black',
      }}
    />
  );
};

export default CalendarBox;
